import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/all",
    name: "All",
    props: true,
    component: () => import(/* webpackChunkName: "all" */ "../views/All.vue"),
  },
  {
    path: "/request/:clientId",
    name: "Request",
    props: true,
    component: () =>
      import(/* webpackChunkName: "request" */ "../views/Request.vue"),
  },
  {
    path: "/manage/:clientId",
    name: "Manage",
    props: true,
    component: () =>
      import(/* webpackChunkName: "manage" */ "../views/Manage.vue"),
  },
  {
    path: "*",
    component: () =>
      import(/* webpackChunkName: '404' */ "../components/404.vue"),
  },
]

const router = new VueRouter({
  mode: "history",
  routes,
})

export default router
